var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out",
    transform: "translate(-1472 -114)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M-512.373,15752.354h-6.816a2.614,2.614,0,0,1-2.613-2.609v-11.936a2.614,2.614,0,0,1,2.613-2.609h6.816a2.612,2.612,0,0,1,2.609,2.609v1.356a.58.58,0,0,1-.577.581.58.58,0,0,1-.577-.581v-1.356a1.456,1.456,0,0,0-1.455-1.455h-6.816a1.456,1.456,0,0,0-1.455,1.455v11.936a1.456,1.456,0,0,0,1.455,1.454h6.816a1.456,1.456,0,0,0,1.455-1.454v-1.356a.58.58,0,0,1,.577-.581.58.58,0,0,1,.577.581v1.356A2.612,2.612,0,0,1-512.373,15752.354Zm5.333-5.729a.565.565,0,0,1-.407-.17.559.559,0,0,1-.17-.407.555.555,0,0,1,.17-.407l1.249-1.254h-8.381a.578.578,0,0,1-.577-.577.578.578,0,0,1,.577-.577h8.381l-1.249-1.249a.574.574,0,0,1-.17-.411.555.555,0,0,1,.17-.407.565.565,0,0,1,.407-.17.58.58,0,0,1,.411.17l1.518,1.519a1.581,1.581,0,0,1,.465,1.126,1.582,1.582,0,0,1-.465,1.127l-1.518,1.519A.58.58,0,0,1-507.04,15746.626Z",
    transform: "translate(1997.223 -15617.777)",
    fill: "#0c0c0b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.be308f09.svg";
export { ForwardRef as ReactComponent };